import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import PayReturn from "./pages/PayReturn";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/pay/return" element={<PayReturn mode="return" />} />
          <Route path="/pay/cancel" element={<PayReturn mode="cancel" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
